import { render, staticRenderFns } from "./AllService.vue?vue&type=template&id=5c89b096&scoped=true"
import script from "./AllService.vue?vue&type=script&lang=js"
export * from "./AllService.vue?vue&type=script&lang=js"
import style0 from "./AllService.vue?vue&type=style&index=0&id=5c89b096&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89b096",
  null
  
)

export default component.exports